class t {
  /**
   * It checks the window inner width to determine whether the current device is desktop or not
   * @returns true if the inner width is greater than 1024
   */
  static isDesktop() {
    return window.innerWidth > 1024;
  }
}
export {
  t as R
};
